import React, { useEffect, useState } from 'react'
import axios from 'axios';
import { useSearchParams } from 'react-router-dom';
import { FaGift } from 'react-icons/fa';
import { MdChevronLeft } from 'react-icons/md';
import BenefitCard from '../copmponents/BenefitCard';

const Benefits = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  // מזהה הטבה שמגיע מקישור שיתוף של האדמין: /Mobile/Benefits?benefitId=<id>
  const benefitId = searchParams.get("benefitId");
  const [benefits, setBenefits] = useState([]);
  const [loading, setLoading] = useState(true);
  const GET_URL = "dashboard/member/benefits";

  const getData = async () => {
    setLoading(true);
    try {
      // ללא benefitId axios משמיט את הפרמטר והשרת מחזיר את כל ההטבות
      const response = await axios.get(GET_URL, { params: { benefitId } });
      if (response.status === 200) {
        const data = response?.data;
        // השרת עשוי להחזיר רשימה או הטבה בודדת — מנרמלים תמיד לרשימה
        let list = Array.isArray(data) ? data : (data && typeof data === 'object' ? [data] : []);
        // מציגים רק את ההטבה המבוקשת גם אם השרת יחזיר רשימה מלאה
        if (benefitId) list = list.filter(b => String(b?.id) === benefitId);
        setBenefits(list);
      }
    } catch (error) {
      console.error("Error fetching benefits:", error);
      setBenefits([]); // מזהה שלא קיים / לא תקין -> "ההטבה לא נמצאה"
    } finally {
      setLoading(false);
    }
  };

  // טעינה מחדש גם כשעוברים מהטבה בודדת (מקישור) לכל ההטבות
  useEffect(() => {
    getData();
  }, [benefitId]);

  return (
    <div className='w-full flex flex-col'>
      <h1 className='text-right mr-3 font-semibold text-[#0042F5] text-lg'>הטבות</h1>
      {benefitId && (
        <button
          type="button"
          dir="rtl"
          onClick={() => setSearchParams({}, { replace: true })}
          className='self-end mr-3 mt-2 inline-flex items-center gap-1.5 rounded-full bg-[#0042F5] text-white text-sm font-semibold px-4 py-1.5 shadow-md hover:bg-[#0036c7] active:scale-95 transition'
        >
          <FaGift size={14} className="shrink-0" />
          לכל ההטבות
          <MdChevronLeft size={18} className="shrink-0" />
        </button>
      )}
      <div className="w-full grid grid-cols-2 my-2 gap-3 p-2">
        {!loading && !benefits.length && (
          <h2 className="col-span-2">{benefitId ? "ההטבה לא נמצאה או שאינה זמינה יותר" : "-לא קיימות הטבות- "}</h2>
        )}
        {benefits.map((benefit, index) => (
          <BenefitCard benefit={benefit} key={benefit?.id ?? index} />
        ))}
      </div>
    </div>
  );
};

export default Benefits;
